import { render, staticRenderFns } from "./FormPage.vue?vue&type=template&id=5a3a7c9a&scoped=true"
import script from "./FormPage.vue?vue&type=script&lang=js"
export * from "./FormPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3a7c9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a3a7c9a')) {
      api.createRecord('5a3a7c9a', component.options)
    } else {
      api.reload('5a3a7c9a', component.options)
    }
    module.hot.accept("./FormPage.vue?vue&type=template&id=5a3a7c9a&scoped=true", function () {
      api.rerender('5a3a7c9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/commonPage/pages/FormPage.vue"
export default component.exports